var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.328 27.6472C27.929 27.6472 31.6589 23.9173 31.6589 19.3163C31.6589 14.7152 27.929 10.9854 23.328 10.9854C18.727 10.9854 14.9971 14.7152 14.9971 19.3163C14.9971 23.9173 18.727 27.6472 23.328 27.6472Z",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 45.9741C7.76483 42.2076 9.80829 38.8213 12.7841 36.389C15.76 33.9567 19.4852 32.6279 23.3286 32.6279C27.172 32.6279 30.8972 33.9567 33.8731 36.389C36.8489 38.8213 38.8924 42.2076 39.6572 45.9741",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6564 2.6543H5.00034C3.15992 2.6543 1.66797 4.14625 1.66797 5.98667V42.6427C1.66797 44.4832 3.15992 45.9751 5.00034 45.9751H41.6564C43.4968 45.9751 44.9888 44.4832 44.9888 42.6427V5.98667C44.9888 4.14625 43.4968 2.6543 41.6564 2.6543Z",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBlue);
export default __webpack_public_path__ + "static/media/man-blue.a4e7fea03f4bbaf872b4bf4b73bd2d3e.svg";
export { ForwardRef as ReactComponent };